import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import EventImage from 'components/event-image/EventImage';
import Heading from 'components/heading/Heading';
import DataTagList from 'components/data-tag-list/DataTagList';
import ImageTag from 'components/image-tag/ImageTag';

import { ICard } from 'source/NFR.types';

export interface CardProps extends ICard {
  isEvent?: boolean;
  sizes?: string;
}

const Card: React.FC<CardProps> = ({
  link,
  image = undefined,
  eventImage = undefined,
  preTitle,
  title,
  text,
  imageTag,
  dataTagList,
  isPriority = false,
  isEvent,
  sizes
}) => {
  const LinkOrDiv = link ? 'a' : 'div';
  const linkProps = link
    ? {
        href: link.url,
        'aria-label': [preTitle, link.label ?? title].filter(Boolean).join(' ') || undefined
      }
    : undefined;

  return (
    <LinkOrDiv className="card" {...linkProps}>
      {(image || isEvent) && (
        <div className="card--image">
          {imageTag && <ImageTag label={imageTag} />}
          {image && !isEvent && (
            <Image
              {...imageSizes.card}
              {...image}
              sizes={sizes}
              loading={isPriority ? 'eager' : 'lazy'}
              fetchPriority={isPriority ? 'high' : 'auto'}
            />
          )}
          {isEvent && !image && eventImage && (
            <EventImage
              {...eventImage}
              isEvent={isEvent}
              sizes={sizes}
              loading={isPriority ? 'eager' : 'lazy'}
              fetchPriority={isPriority ? 'high' : 'auto'}
            />
          )}
        </div>
      )}

      <div>
        {preTitle && (
          <div className="card--date">
            <span className="card--date-dot" />
            <time dateTime={preTitle} className="card--date-text">
              {preTitle}
            </time>
          </div>
        )}
        {title && (
          <Heading className="card--title" level={3}>
            {title}
          </Heading>
        )}
        {text && <p className="card--text">{text}</p>}
        {dataTagList && <DataTagList list={dataTagList} />}
      </div>
    </LinkOrDiv>
  );
};

Card.displayName = 'Card';

export default Card;
